var map = {
	"./energy_transporter.png": "4c02",
	"./logo-telis.png": "69b0",
	"./marine_insurance.png": "92f3",
	"./renjani_maritim.png": "d2943",
	"./sentra_makmur.png": "a464",
	"./tcp-logo.png": "64d9",
	"./trans_energi_logistik.png": "7fb7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "818c";